import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { PostsService } from '../modules/core/services/posts.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Natjecaj } from '../model';

@Component({
  standalone: false,
  selector: 'app-enter-email',
  templateUrl: './enter-email.component.html',
  styleUrls: ['./enter-email.component.scss'],
})
export class EnterEmailComponent implements OnInit {
  //export class EnterEmailComponent  implements OnInit {

  constructor(
    private fb: FormBuilder,
    public postsService: PostsService,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}

  emailForm!: FormGroup;
  poruka: any;
  email: string = '';
  successMessage: string | null = null;
  errorMessage: string | null = null;
  isError!: boolean;
  hostUrl :string = window.location.origin+environment.routeTo+'/token-login';
  emailSent:boolean = false;





  sendLink() {
    this.postsService.sendEmailService(this.email, this.hostUrl).subscribe({
      next: (msg:string) => {
        
        this.errorMessage = '';
        this.successMessage = 'Email je uspješno poslan.';
        this.isError = false;
        this.emailSent=true;

      },
      error: (err) => {
        console.error(err);
        this.successMessage = '';
        this.errorMessage = 'Došlo je do greške prilikom slanja e-pošte. Molimo pokušajte ponovo.';
        this.isError = true;
      },
    });
 
  }

  showAdditionalInfo = false;

  showInfo() {
    this.showAdditionalInfo = !this.showAdditionalInfo;
  }


  isTooltipVisible = false;

  toggleTooltip() {
    this.isTooltipVisible = !this.isTooltipVisible;


    setTimeout(() => {
      this.isTooltipVisible = false;
    }, 4200);
  }



  ngOnInit(): void {
     }
}
